import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v1`;

const api = axios.create({ baseURL: API });

let accessToken = localStorage.getItem("urlifa_access") || null;
let refreshToken = localStorage.getItem("urlifa_refresh") || null;

export function setTokens(access, refresh) {
  accessToken = access;
  refreshToken = refresh;
  if (access) localStorage.setItem("urlifa_access", access);
  else localStorage.removeItem("urlifa_access");
  if (refresh) localStorage.setItem("urlifa_refresh", refresh);
  else localStorage.removeItem("urlifa_refresh");
}

export function clearTokens() {
  setTokens(null, null);
}

export function getRefreshToken() {
  return refreshToken;
}

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && refreshToken) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios.post(`${API}/auth/refresh`, { refresh_token: refreshToken });
        }
        const { data } = await refreshing;
        refreshing = null;
        setTokens(data.access_token, data.refresh_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        clearTokens();
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
